import { ComponentRef, Injector, TemplateRef } from '@angular/core';
import { Injectable } from '@angular/core';

import { ComponentPortal } from 'app/ui/core/portal';
import { ComponentType } from 'app/ui/core/portal';
import { Overlay } from 'app/ui/core/overlay';
import { OverlayRef } from 'app/ui/core/overlay-ref';
import { UISnackBarComponent } from './snack-bar.component';
import { TemplatePortal } from 'app/ui/core/portal';

@Injectable()
export class UISnackBarService {

    private _overlayRef: OverlayRef;

    private _timeout: number;

    constructor(private _injector: Injector, private _overlay: Overlay) {
    }

    open<T>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>): void {
        this._destroySnackBar();
        this._overlayRef = this._createOverlay();
        const snackBarContainer = this._attachSnackBarContainerComponent();
        this._attachSnackBarContent(componentOrTemplateRef, snackBarContainer);

        clearTimeout(this._timeout);
        this._timeout = window.setTimeout(() => {
            this._destroySnackBar();
        }, 5250);
    }

    private _destroySnackBar() {
        if (this._overlayRef) {
            this._overlayRef.detachBackdrop();
            this._overlayRef.dispose();
        }
    }

    private _createOverlay(): OverlayRef {
        return this._overlay.create({ hasBackdrop: false });
    }

    private _attachSnackBarContent<T>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
        snackBarContainer: UISnackBarComponent): void {
        // Create a reference to the snackBar we're creating in order to give the user a handle
        // to modify and close it.

        if (componentOrTemplateRef instanceof TemplateRef) {
            snackBarContainer.attachTemplatePortal(new TemplatePortal(componentOrTemplateRef, null));
        } else {
            snackBarContainer.attachComponentPortal(new ComponentPortal(componentOrTemplateRef, null, this._injector));
        }
    }

    private _attachSnackBarContainerComponent(): UISnackBarComponent {
        const containerPortal = new ComponentPortal(UISnackBarComponent, null);

        const containerRef: ComponentRef<UISnackBarComponent> = this._overlayRef.attach(containerPortal);

        return containerRef.instance;
    }

}